import { useTranslateGetObject } from "./useTranslateGetObject";

export const useCertifications = () => {
  const certifications = useTranslateGetObject("about.certifications");
  return [certifications];
}